import { render, staticRenderFns } from "./CheckMark.vue?vue&type=template&id=5d89f53e&scoped=true&"
import script from "./CheckMark.vue?vue&type=script&lang=js&"
export * from "./CheckMark.vue?vue&type=script&lang=js&"
import style0 from "./CheckMark.vue?vue&type=style&index=0&id=5d89f53e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89f53e",
  null
  
)

export default component.exports